export type AggregatedEntry = {
    id: string;
    mountActualDuration: number | null;
    mountBaseDuration: number | null;
    updateCount: number;
    updateTotalActualDuration: number;
    updateMaxActualDuration: number;
    updateMinActualDuration: number;
};

const createEmptyEntry = (id: string): AggregatedEntry => ({
    id,
    mountActualDuration: null,
    mountBaseDuration: null,
    updateCount: 0,
    updateTotalActualDuration: 0,
    updateMaxActualDuration: 0,
    updateMinActualDuration: Infinity
});

const entries = new Map<string, AggregatedEntry>();

export const record = (id: string, phase: string, actualDuration: number, baseDuration: number): void => {
    let entry = entries.get(id);
    if (!entry) {
        entry = createEmptyEntry(id);
        entries.set(id, entry);
    }

    if (phase === 'mount') {
        // Mount is captured once — first mount wins
        if (entry.mountActualDuration === null) {
            entry.mountActualDuration = Math.round(actualDuration * 100) / 100;
            entry.mountBaseDuration = Math.round(baseDuration * 100) / 100;
        }
    } else {
        entry.updateCount += 1;
        entry.updateTotalActualDuration += actualDuration;
        entry.updateMaxActualDuration = Math.max(entry.updateMaxActualDuration, actualDuration);
        entry.updateMinActualDuration = Math.min(entry.updateMinActualDuration, actualDuration);
    }
};

export const flush = (): AggregatedEntry[] => {
    const results = Array.from(entries.values()).map((entry) => {
        return {
            ...entry,
            updateTotalActualDuration: Math.round(entry.updateTotalActualDuration * 100) / 100,
            updateMaxActualDuration: entry.updateCount > 0 ? Math.round(entry.updateMaxActualDuration * 100) / 100 : 0,
            updateMinActualDuration: entry.updateCount > 0 ? Math.round(entry.updateMinActualDuration * 100) / 100 : 0
        };
    });

    entries.clear();
    return results;
};

export const reset = (): void => {
    entries.clear();
};
